var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1027"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8399 18.5H7.3599C7.16108 18.5 6.9999 18.3388 6.9999 18.14V15.86C6.9999 15.6612 7.16108 15.5 7.3599 15.5H10.8399C11.0387 15.5 11.1999 15.6612 11.1999 15.86V18.14C11.1999 18.3388 11.0387 18.5 10.8399 18.5Z",
    stroke: "#FEFEFE",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1399 9.5H10.6599C10.4611 9.5 10.2999 9.33882 10.2999 9.14V6.86C10.2999 6.66118 10.4611 6.5 10.6599 6.5H14.1399C14.3388 6.5 14.4999 6.66118 14.4999 6.86V9.14C14.4999 9.33882 14.3388 9.5 14.1399 9.5Z",
    stroke: "#FEFEFE",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.4399 18.5H13.9599C13.7611 18.5 13.5999 18.3388 13.5999 18.14V15.86C13.5999 15.6612 13.7611 15.5 13.9599 15.5H17.4399C17.6387 15.5 17.7999 15.6612 17.7999 15.86V18.14C17.7999 18.3388 17.6387 18.5 17.4399 18.5Z",
    stroke: "#FEFEFE",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.09987 15.5V13.4C9.09987 13.0817 9.2263 12.7765 9.45135 12.5515C9.67639 12.3264 9.98161 12.2 10.2999 12.2H14.4999C14.8181 12.2 15.1234 12.3264 15.3484 12.5515C15.5734 12.7765 15.6999 13.0817 15.6999 13.4V15.5M12.3999 12.2V9.5",
    stroke: "#FEFEFE",
    strokeWidth: 0.75
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.6d296b336730520f190c1da096d4c493.svg";
export { ForwardRef as ReactComponent };